import { render } from "./LinkOpenBankingAccountPage.vue?vue&type=template&id=0f7a0898&scoped=true"
import script from "./LinkOpenBankingAccountPage.vue?vue&type=script&lang=js"
export * from "./LinkOpenBankingAccountPage.vue?vue&type=script&lang=js"

import "./LinkOpenBankingAccountPage.vue?vue&type=style&index=0&id=0f7a0898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7a0898"]])

export default __exports__